export const IMAGE_ZOOM_MIN = 1;
export const IMAGE_ZOOM_MAX = 4;
export const IMAGE_ZOOM_STEP = 0.12;

export interface ImageZoomTransform {
	scale: number;
	translateX: number;
	translateY: number;
}

export function clampImageScale(scale: number): number {
	return Math.min(IMAGE_ZOOM_MAX, Math.max(IMAGE_ZOOM_MIN, scale));
}

export function resetImageZoomTransform(): ImageZoomTransform {
	return { scale: IMAGE_ZOOM_MIN, translateX: 0, translateY: 0 };
}

export function zoomImageScale(current: number, delta: number): number {
	return clampImageScale(current + delta);
}

export function applyWheelZoom(
	transform: ImageZoomTransform,
	deltaY: number,
	pointerX: number,
	pointerY: number,
	viewportWidth: number,
	viewportHeight: number,
): ImageZoomTransform {
	const direction = deltaY > 0 ? -1 : 1;
	const nextScale = clampImageScale(transform.scale + direction * IMAGE_ZOOM_STEP);
	if (nextScale === transform.scale) {
		return transform;
	}

	const ratio = nextScale / transform.scale;
	const centerX = viewportWidth / 2;
	const centerY = viewportHeight / 2;
	const offsetX = pointerX - centerX;
	const offsetY = pointerY - centerY;

	let translateX = transform.translateX - offsetX * (ratio - 1);
	let translateY = transform.translateY - offsetY * (ratio - 1);

	if (nextScale === IMAGE_ZOOM_MIN) {
		translateX = 0;
		translateY = 0;
	}

	return { scale: nextScale, translateX, translateY };
}

export function applyPan(
	transform: ImageZoomTransform,
	deltaX: number,
	deltaY: number,
): ImageZoomTransform {
	if (transform.scale <= IMAGE_ZOOM_MIN) {
		return transform;
	}
	return {
		...transform,
		translateX: transform.translateX + deltaX,
		translateY: transform.translateY + deltaY,
	};
}

export function applyPinchZoom(
	transform: ImageZoomTransform,
	scaleFactor: number,
): ImageZoomTransform {
	const nextScale = clampImageScale(transform.scale * scaleFactor);
	if (nextScale === IMAGE_ZOOM_MIN) {
		return resetImageZoomTransform();
	}
	return { ...transform, scale: nextScale };
}
